module.exports = __webpack_public_path__ + "static/img/odd.70d2852.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/full/projects/odd.svg
// module id = lt/i
// module chunks = 0